import React from 'react';

import styles from './Dropdown.module.css';

interface Options {
  name: string;
  value: string;
}

interface Props {
  label: string;
  name: string;
  options: Options[];
  onChange: (value: React.ChangeEvent<HTMLSelectElement>) => void;
  value: string;
  disabled?: boolean;
}

export default function Dropdown({
  label, name, options = [], onChange, value, disabled,
}: Props) {
  return (
    <label
      htmlFor={name}
      className={styles.dropdown}
    >
      {label}
      <select
        name={name}
        onChange={onChange}
        value={value}
        className={styles.select}
        disabled={disabled}
        data-cy={name}
      >
        {
          options.map((option) => (
            <option
              key={option.value}
              value={option.value}
            >
              {option.name}
            </option>
          ))
        }
      </select>
    </label>
  );
}
